import type { MigrationInterface, QueryRunner } from 'typeorm'

export class AddProjectDatesTable1678791241996 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration UP (AddProjectDatesTable1678791241996)')
    await queryRunner.query(`
            CREATE TABLE IF NOT EXISTS "projectDates" (
                "id" integer PRIMARY KEY NOT NULL,
                "name" varchar NOT NULL,
                "number" varchar,
                "start_date" varchar,
                "end_date" varchar,
                "rrule" varchar,
                "description" varchar,
                "location" varchar,
                "completed_date" varchar,
                "project_id" integer NOT NULL,
                FOREIGN KEY ("project_id") REFERENCES "projects" ("id") ON DELETE CASCADE ON UPDATE CASCADE
            );
        `)
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration DOWN (AddProjectDateTable1678791241996)')
    await queryRunner.query(`
            DROP TABLE "projectDates";
        `)
  }
}
